<template>
    <v-dialog :value="msg != null" max-width="80vw" persistent>
        <v-card :color="color" :loading="timer > 0">
            <template slot="progress">
                <v-progress-linear height="10" color="white" :value="timerNow > 0 ? ((timerNow / timer) * 100) : 0" />
            </template>
            <v-card-text class="text-center pt-8" v-if="icon">
                <v-icon x-large color="white">{{ icon }}</v-icon>
            </v-card-text>

            <slot name="beforeMessage"></slot>

            <v-card-text class="text-center headline white--text">{{ msg }}</v-card-text>

            <v-card-text class="text-center" v-if="subtitle">
                {{ subtitle }}
            </v-card-text>

            <v-card-text class="text-center white--text">
                <slot name="afterMessage"></slot>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn @click="closeBeepFeedback" dark small outlined>{{ $t("Fechar") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { beepError, beepErrorSoft } from "@/helpers/Beep";

export default {
    name: "MessageDialog",

    props: {
        options: {
            type: Object,
            default: undefined,
        },
    },

    data() {
        return {
            beepError,
            beepErrorSoft,
            timer: null,
            msg: null,
            subtitle: undefined,
            icon: "message",
            color: null,
            timerNow: null,
            timerInstance: null,
        };
    },

    watch: {
        options: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal) {
                    if (newVal.type && newVal.msg) {
                        if (newVal.type == "success" && !newVal.timer) {
                            this.$eventHub.$emit("msgSuccess", newVal.msg);
                            this.closeBeepFeedback();
                        } else {

                            if (newVal.type == "critical")
                                this.beepError();
                            else if (newVal.type == "warning")
                                this.beepErrorSoft();

                            if (newVal.type == "critical") {
                                this.color = "error";
                                this.icon = "warning";
                            } else if (newVal.type == "info") {
                                this.color = "primary";
                                this.icon = "message";
                            } else {
                                this.color = newVal.type;
                            }

                            this.msg = newVal.msg;

                            if (newVal.timer) {
                                this.timerNow = newVal.timer / 100;
                                this.timer = newVal.timer / 100;
                                this.timerTick();
                            }
                        }
                        if (newVal.subtitle) {
                            this.subtitle = newVal.subtitle;
                        } else {
                            this.subtitle = undefined;
                        }
                    }
                }
            },
        },
    },

    methods: {
        closeBeepFeedback() {
            this.$emit("close");
            this.msg = null;
            this.timerNow = null;
            this.timer = null;
            if (this.timerInstance) {
                clearInterval(this.timerInstance);
            }
            this.timerInstance = null;
        },
        timerTick() {
            if (this.timerInstance) {
                clearInterval(this.timerInstance);
            }
            this.timerInstance = setInterval(() => {
                if (this.timerNow > 0) {
                    this.timerNow--;
                } else {
                    this.closeBeepFeedback();
                }
            }, 100);
        },
    },

    beforeDestroy() {
        clearInterval(this.timerInstance);
    },
};
</script>
